import './ShowLessonsModel.css';
  import '../../../firstpage/home.css';

 import ChapterPreview from './ChapterPreview';

import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef
} from 'react';

  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 import {
  
  faPuzzlePiece,
  faArrowUp,
  faArrowDown,
 faScaleBalanced,
  faBookOpen,
  faChevronUp,
  faChevronDown,
  faDumbbell,
  faForwardFast,
  faPlay,
  faBoltLightning,
  faGraduationCap,
  faTrophy
} from '@fortawesome/free-solid-svg-icons';
  import { useNavigate, useLocation, Link } from 'react-router-dom';


  import giftClosed from '../../../imagesHome/giftclosed.png';
  import giftOpen from '../../../imagesHome/giftopen.png';
    import brainreview from '../../../imagesHome/brain_review.png';
    import chaptericon from '../../../imagesHome/chapter_icon.png';
   
      import road from '../../../imagesHome/road.png';
       import finish from '../../../imagesHome/finish.png';
        import diploma from '../../../imagesHome/progress-card.png';
 
    // moved to showlessonsmodel.jsx (lowercase)
    import '../leftSidebar/pages/reglaredimensiune.css';
    import courseConfigs from '../../../config/courseConfigs';



      

  
  import { FloatingLessonBubble} from '../../lessonstyles/FloatingLessonBubble';




  import LessonSeparator from '../../lessonstyles/LessonSeparator';





  import TopBar from '../topBar/TopBar';



export const ShowLessonsModel = ({
  courseConfig = courseConfigs.baze,
  hasPremiumAccess = false
}) => {


  const theme = courseConfig.theme || courseConfigs.baze.theme;

  
const isFinancialCourse =
  Number(courseConfig.courseId) === 2;


const [premiumStatus, setPremiumStatus] = useState({
  loading: isFinancialCourse,
  isPremium: false
});

useEffect(() => {
  if (!isFinancialCourse) {
    return;
  }

  let cancelled = false;

  const fetchPremiumStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user`,
        {
          method: 'GET',
          credentials: 'include'
        }
      );

      if (!response.ok) {
        throw new Error(
          'Nu s-a putut verifica statutul Premium'
        );
      }

      const data = await response.json();

      if (!cancelled) {
        setPremiumStatus({
          loading: false,
          isPremium: data?.is_premium === true
        });
      }

    } catch (error) {
      console.error(
        'Eroare verificare Premium:',
        error
      );

      if (!cancelled) {
        setPremiumStatus({
          loading: false,
          isPremium: false
        });
      }
    }
  };

  setPremiumStatus({
    loading: true,
    isPremium: false
  });

  fetchPremiumStatus();

  return () => {
    cancelled = true;
  };
}, [isFinancialCourse]);



    const [showLessonsMain, setShowLessonsMain] = useState(true);
    const [activePanel, setActivePanel] = useState(null);

const [previewChapter, setPreviewChapter] = useState(null);

useEffect(() => {
  if (previewChapter) {
    document.body.classList.add('chapter-preview-open');
  } else {
    document.body.classList.remove('chapter-preview-open');
  }

  return () => {
    document.body.classList.remove('chapter-preview-open');
  };
}, [previewChapter]);

    const getPanelKey = (chapter, lessonId) => `chapter-${chapter}-lesson-${lessonId}`;

const [floatingLesson, setFloatingLesson] = useState(null);

const scrollerRef = useRef(null);

useEffect(() => {
  const handleGlobalWheel = (event) => {
    // Pe mobil/tableta pastram comportamentul nativ
    if (window.innerWidth <= 1100) {
      return;
    }

    const scroller = scrollerRef.current;

    if (!scroller) {
      return;
    }

    const target = event.target;

    // Nu fortam scroll-ul daca utilizatorul interactioneaza
    // cu un camp de formular
    if (
      target instanceof HTMLElement &&
      (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT'
      )
    ) {
      return;
    }

    // Daca nu mai avem unde sa scrollam,
    // nu blocam inutil evenimentul.
    const scrollingDown = event.deltaY > 0;
    const scrollingUp = event.deltaY < 0;

    const atTop = scroller.scrollTop <= 0;

    const atBottom =
      scroller.scrollTop + scroller.clientHeight >=
      scroller.scrollHeight - 1;

    if (
      (scrollingUp && atTop) ||
      (scrollingDown && atBottom)
    ) {
      return;
    }

    event.preventDefault();

    scroller.scrollTop += event.deltaY;
  };

  window.addEventListener(
    'wheel',
    handleGlobalWheel,
    { passive: false }
  );

  return () => {
    window.removeEventListener(
      'wheel',
      handleGlobalWheel
    );
  };
}, []);


const [showInitialFloating, setShowInitialFloating] = useState(false);

const floatingPanelWrapperRef = useRef(null);
const skipNextScrollClose = useRef(false);
const isUserScrolling = useRef(false);

const scrollProtectorRef = useRef(false);
const [isActiveLessonVisible, setIsActiveLessonVisible] = useState(true);
const [scrollDirectionUp, setScrollDirectionUp] = useState(false);
const congratsRef = useRef(null);
const certificateRef = useRef(null);
const hasScrolledToCertificate = useRef(false);
const [hideScrollButton, setHideScrollButton] = useState(false);
const [loadingLesson, setLoadingLesson] = useState(false);









const [isDesktop, setIsDesktop] = useState(() =>
  typeof window !== 'undefined' && window.matchMedia('(min-width: 1121px)').matches
);

useEffect(() => {
  const mql = window.matchMedia('(min-width: 1121px)');
  const onChange = (e) => setIsDesktop(e.matches);
  mql.addEventListener?.('change', onChange);
  return () => mql.removeEventListener?.('change', onChange);
}, []);

useEffect(() => {
  const html = document.documentElement;
  const body = document.body;

  html.classList.add('showlessons-active');
  body.classList.add('showlessons-active');

  return () => {
    html.classList.remove('showlessons-active');
    body.classList.remove('showlessons-active');
  };
}, []);

const prevLessonRef = useRef(null);









const lessonRefs = useRef({});                  




useEffect(() => {
  const updateColumnPosition = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    document.documentElement.style.setProperty('--lesson-column-left', `${rect.left}px`);
  };

  updateColumnPosition();
  window.addEventListener('resize', updateColumnPosition);
  window.addEventListener('scroll', updateColumnPosition, { passive: true });

  return () => {
    window.removeEventListener('resize', updateColumnPosition);
    window.removeEventListener('scroll', updateColumnPosition);
  };
}, []);



useEffect(() => {
  const el = scrollerRef.current;
  if (!el) return;

  const setVars = () => {
    const r = el.getBoundingClientRect();
    const root = document.documentElement.style;
    root.setProperty('--lesson-col-left', `${r.left}px`);
    root.setProperty('--lesson-col-right', `${window.innerWidth - r.right}px`);
    root.setProperty('--lesson-col-width', `${r.width}px`);
  };

  setVars();

  // ținem valorile la zi când se schimbă layoutul
  const ro = new ResizeObserver(setVars);
  ro.observe(el);

  window.addEventListener('resize', setVars);
  window.addEventListener('scroll', setVars, { passive: true });

  return () => {
    ro.disconnect();
    window.removeEventListener('resize', setVars);
    window.removeEventListener('scroll', setVars);
  };
}, []);



    const panelRef = useRef(null);
    const lessonButtonRef = useRef(null);

    const unhideLessons = () => setShowLessonsMain(!showLessonsMain);

    const [chapters, setChapters] = useState([]);
    

    // Identificam primele doua lectii obisnuite
// din intregul curs financiar.
const freeFinancialLessonKeys = (
  isFinancialCourse
    ? chapters.flatMap((chapter) =>
        (chapter.lessons || [])
          .filter((lesson) =>
            String(lesson.explanationType || '')
              .toLowerCase() !== 'jumphere'
          )
          .map((lesson) =>
            `${chapter.id}-${lesson.lesson}`
          )
      ).slice(0, 2)
    : []
);
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(true);

   




    const location = useLocation();
    const { updatedProgress } = location.state || {};

    const fromStart = location.state?.fromStart || false;

const [showWelcome, setShowWelcome] = useState(fromStart);

    const tothelesson = useNavigate();

    const [lessonProgress, setLessonProgress] = useState({});

    // Cursul e terminat doar cand TOATE lectiile din TOATE capitolele sunt completate.
    const allLessonKeys = (chapters || []).flatMap((chapter) =>
      (chapter?.lessons || []).map((lesson) => `${chapter.id}-${lesson.lesson}`)
    );

    const isCourseCompleted =
      allLessonKeys.length > 0 &&
      allLessonKeys.every((key) => Boolean(lessonProgress?.[key]?.completed));


useEffect(() => {
  if (
    !isCourseCompleted ||
    pageLoading ||
    hasScrolledToCertificate.current
  ) {
    return;
  }

  let cancelled = false;
  let retryCount = 0;
  const MAX_RETRIES = 30;

  const scrollToCertificate = () => {
    if (
      cancelled ||
      hasScrolledToCertificate.current
    ) {
      return;
    }

    const scroller = scrollerRef.current;
    const certificate = certificateRef.current;

    if (!scroller || !certificate) {
      retryCount += 1;

      if (retryCount <= MAX_RETRIES) {
        requestAnimationFrame(scrollToCertificate);
      }

      return;
    }

    hasScrolledToCertificate.current = true;

    const scrollerRect =
      scroller.getBoundingClientRect();

    const certificateRect =
      certificate.getBoundingClientRect();

    const certificateTop =
      certificateRect.top -
      scrollerRect.top +
      scroller.scrollTop;

    /*
     * Pozitionam cardul certificatului
     * aproximativ in centrul zonei vizibile.
     */
    const targetTop =
      certificateTop -
      (scroller.clientHeight / 2) +
      (certificate.offsetHeight / 2);

    scroller.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth'
    });
  };

  const timer = setTimeout(() => {
    requestAnimationFrame(scrollToCertificate);
  }, 250);

  return () => {
    cancelled = true;
    clearTimeout(timer);
  };
}, [
  isCourseCompleted,
  pageLoading,
  location.key
]);


const [activeChapters, setActiveChapters] = useState({});

const [learningMode, setLearningMode] = useState('progressive');
const [selectedChapterId, setSelectedChapterId] = useState(null);
const [moduleSelectionPopup, setModuleSelectionPopup] = useState(null);

const [courseStateLoaded, setCourseStateLoaded] = useState(false);

useEffect(() => {
  let cancelled = false;

  const loadCourseState = async () => {
    setCourseStateLoaded(false);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/user/course-state?courseId=${courseConfig.courseId}`,
        {
          credentials: 'include'
        }
      );

      if (!response.ok) {
        throw new Error('Nu s-a putut incarca starea cursului');
      }

      const data = await response.json();

      if (cancelled) return;

      setLearningMode(
        data.learningMode === 'module'
          ? 'module'
          : 'progressive'
      );

      setSelectedChapterId(
        data.learningMode === 'module'
          ? data.selectedChapterId
          : null
      );

    } catch (error) {
      console.error(
        'Eroare la incarcarea starii cursului:',
        error
      );

      if (!cancelled) {
        setLearningMode('progressive');
        setSelectedChapterId(null);
      }

    } finally {
      if (!cancelled) {
        setCourseStateLoaded(true);
      }
    }
  };

  loadCourseState();

  return () => {
    cancelled = true;
  };
}, [courseConfig.courseId]);

    
const collapseScrollTargetRef = useRef(null);

const toggleChapter = (chapterIndex, event) => {
  const isCollapsing = Boolean(activeChapters[chapterIndex]);
  const scroller = scrollerRef.current;

  const chapterBlock =
    event.currentTarget.closest('.chapter-block');

  collapseScrollTargetRef.current = null;

  if (isCollapsing && scroller && chapterBlock) {
    const header = chapterBlock.querySelector(
      '.chapter-header-sticky-wrapper'
    );

    if (header) {
      const scrollerTop =
        scroller.getBoundingClientRect().top +
        scroller.clientTop;

      const stickyTop =
        parseFloat(window.getComputedStyle(header).top) || 0;

      // Pastram antetul la pozitia lui vizibila,
      // cel putin sub bara de sus.
      const visibleHeaderOffset = Math.max(
        stickyTop,
        header.getBoundingClientRect().top - scrollerTop
      );

      // Calculam inainte sa dispara lectiile.
      // Folosim inceputul modulului, nu pozitia antetului sticky.
      collapseScrollTargetRef.current = Math.max(
        0,
        scroller.scrollTop +
          chapterBlock.getBoundingClientRect().top -
          scrollerTop -
          visibleHeaderOffset
      );
    }
  }

  setFloatingLesson(null);

  setActiveChapters((prev) => ({
    ...prev,
    [chapterIndex]: !prev[chapterIndex]
  }));
};

useLayoutEffect(() => {
  const targetTop = collapseScrollTargetRef.current;

  if (targetTop === null) return;

  collapseScrollTargetRef.current = null;

  const scroller = scrollerRef.current;

  if (!scroller) return;

  // Corectam pozitia dupa restrangere, inainte de afisare.
  scroller.scrollTo({
    top: targetTop,
    behavior: 'instant'
  });
}, [activeChapters]);



const justClosedRef = useRef(false);
    

    const getLessonStatus = (chapterId, lessonId) => {
      const key = `${chapterId}-${lessonId}`;
      const status = lessonProgress[key];
    
      if (!status || !status.unlocked) return 'locked';
      if (status.completed) return 'completed';
      return 'unlocked';
    };

    const getChapterFinalTestKeyByIndex = (chapterList = []) => {
      const finalTestKeyByIndex = {};

      chapterList.forEach((chapter, chapterIndex) => {
        const lessons = Array.isArray(chapter?.lessons) ? chapter.lessons : [];
        let finalTestLesson = null;

        for (let i = lessons.length - 1; i >= 0; i -= 1) {
          const lessonType = String(lessons[i]?.explanationType || '').toLowerCase();
          if (lessonType.includes('test')) {
            finalTestLesson = lessons[i];
            break;
          }
        }

        finalTestKeyByIndex[chapterIndex] = finalTestLesson
          ? `${chapter.id}-${finalTestLesson.lesson}`
          : null;
      });

      return finalTestKeyByIndex;
    };

    const canUnlockJumpHereForChapter = ({
      chapterIndex,
      isJumpHere,
      chapterFinalTestKeyByIndex,
      completedKeySet,
    }) => {
      if (!isJumpHere || chapterIndex === 0) return true;

      const prevChapterFinalTestKey = chapterFinalTestKeyByIndex?.[chapterIndex - 1] || null;
      if (!prevChapterFinalTestKey) return true;

      return completedKeySet.has(prevChapterFinalTestKey);
    };
    
    


  useEffect(() => {
  const timeout = setTimeout(() => {
    setShowWelcome(false);
  }, 3000);

  return () => clearTimeout(timeout);
}, []);







    //cere titlul
useEffect(() => {
  fetch(
    `${process.env.REACT_APP_API_URL}${courseConfig.titlesUrl}`,
    {
      credentials: 'include'
    }
  )
    .then(res => res.json())
    .then(data => {
      setTitles(data);
      setLoading(false);
    })
    .catch(err => {
      console.error('Eroare la fetch:', err);
      setLoading(false);
    });
}, [courseConfig]);



// cere lectiile
useEffect(() => {
  // 1. Încarcă capitolele
fetch(
  `${process.env.REACT_APP_API_URL}${courseConfig.chaptersUrl}`,
  {
    credentials: 'include'
  }
)
    .then((res) => res.json())
    .then((data) => {
      setChapters(data.chapters);
      const activeByDefault = {};
      const progressUnlocked = {};
      // Identifică prima lecție jumphere din tot cursul
      let foundFirstJumpHere = false;
      let firstJumpHereKey = null;
      let firstJumpHereChapterIndex = null;
      data.chapters.forEach((chapter, chapterIndex) => {
        activeByDefault[chapterIndex] = true;
        chapter.lessons.forEach((lesson, lessonIndex) => {
          const key = `${chapter.id}-${lesson.lesson}`;
          const isFirstLesson = chapterIndex === 0 && lessonIndex === 0;
          const isJumpHere = lesson.explanationType?.toLowerCase() === 'jumphere';
          if (!foundFirstJumpHere && isJumpHere) {
            foundFirstJumpHere = true;
            firstJumpHereKey = key;
            firstJumpHereChapterIndex = chapterIndex;
          }
          progressUnlocked[key] = {
            unlocked: isFirstLesson, // doar prima lecție e deblocată implicit
            completed: false,
          };
        });
      });
      // Deblochează și prima lecție jumphere, dacă există
      if (firstJumpHereKey && firstJumpHereChapterIndex === 0) {
        progressUnlocked[firstJumpHereKey].unlocked = true;
      }
      setActiveChapters(activeByDefault);
      // 2. După ce am capitolele, cerem statusul lecțiilor completate
 fetch(
  `${process.env.REACT_APP_API_URL}${courseConfig.progressUrl}`,
  {
    credentials: 'include'
  }
)
        .then(res => res.json())
     .then(completedLessons => {

  const completedSet = new Set(
    completedLessons.map(
      l => `${l.chapter_id}-${l.lesson_id}`
    )
  );

  // Dacă un jumphere este completat, considerăm complete toate lecțiile din spatele lui
  const lessonOrder = [];
  const chapterFinalTestKeyByIndex = getChapterFinalTestKeyByIndex(data.chapters);
  data.chapters.forEach((chapter) => {
    chapter.lessons.forEach((lesson) => {
      lessonOrder.push({
        key: `${chapter.id}-${lesson.lesson}`,
        isJumpHere: lesson.explanationType?.toLowerCase() === 'jumphere',
      });
    });
  });

  const jumpKeysInOrder = lessonOrder
    .filter((entry) => entry.isJumpHere)
    .map((entry) => entry.key);
  const prevJumpByKey = {};
  jumpKeysInOrder.forEach((jumpKey, idx) => {
    prevJumpByKey[jumpKey] = idx > 0 ? jumpKeysInOrder[idx - 1] : null;
  });


const effectiveCompletedSet = new Set(completedSet);

// Un JumpHere completeaza doar lectiile anterioare
// din acelasi capitol/modul.

data.chapters.forEach((chapter) => {
  const lessons = chapter.lessons || [];

  lessons.forEach((lesson, lessonIndex) => {
    const lessonType =
      String(lesson.explanationType || '').toLowerCase();

    const jumpKey = `${chapter.id}-${lesson.lesson}`;

    if (
      lessonType !== 'jumphere' ||
      !completedSet.has(jumpKey)
    ) {
      return;
    }

    // Marcam doar lectiile anterioare
    // din capitolul curent.
    for (let i = 0; i < lessonIndex; i++) {
      const previousLesson = lessons[i];

      const previousKey =
        `${chapter.id}-${previousLesson.lesson}`;

      effectiveCompletedSet.add(previousKey);
    }
  });
});


// Daca lectia dinaintea unui JumpHere este completa,
// consideram automat si JumpHere-ul complet.
// Repetam pana nu mai exista modificari, pentru siguranta.




  const updatedProgress = {};


  // Identifică prima lecție jumphere din tot cursul
  let foundFirstJumpHere = false;
  let firstJumpHereKey = null;
  data.chapters.forEach((chapter, chapterIndex) => {
    chapter.lessons.forEach((lesson, lessonIndex) => {
      const key = `${chapter.id}-${lesson.lesson}`;
      const isJumpHere = lesson.explanationType?.toLowerCase() === 'jumphere';
      if (!foundFirstJumpHere && isJumpHere) {
        foundFirstJumpHere = true;
        firstJumpHereKey = key;
      }
    });
  });

  data.chapters.forEach((chapter, chapterIndex) => {
    chapter.lessons.forEach((lesson, lessonIndex) => {
      const key = `${chapter.id}-${lesson.lesson}`;
      const isCompleted = effectiveCompletedSet.has(key);
      const isFirstLesson = chapterIndex === 0 && lessonIndex === 0;
      const isJumpHere = lesson.explanationType?.toLowerCase() === 'jumphere';
      const prevJumpKey = prevJumpByKey[key];
      const prevLesson = lessonIndex > 0
        ? `${chapter.id}-${chapter.lessons[lessonIndex - 1].lesson}`
        : chapterIndex > 0
          ? (() => {
              const prevChapter = data.chapters[chapterIndex - 1];
              const prevChapterLastLesson = prevChapter?.lessons?.[prevChapter.lessons.length - 1];
              return prevChapterLastLesson
                ? `${prevChapter.id}-${prevChapterLastLesson.lesson}`
                : null;
            })()
          : null;

      // Deblochează dacă e prima lecție, completată, precedenta completată sau este prima jumphere
   

const previousLessonIsNormalizedJump =
  lessonIndex >= 2 &&
  String(
    chapter.lessons[lessonIndex - 1]?.explanationType || ''
  ).toLowerCase() === 'jumphere' &&
  effectiveCompletedSet.has(
    `${chapter.id}-${chapter.lessons[lessonIndex - 2].lesson}`
  );

const isUnlockedByFlow =
  isFirstLesson ||
  isCompleted ||
  (prevLesson && effectiveCompletedSet.has(prevLesson)) ||
  previousLessonIsNormalizedJump ||
  (key === firstJumpHereKey);



      const canUnlockJumpByFinalTest = canUnlockJumpHereForChapter({
        chapterIndex,
        isJumpHere,
        chapterFinalTestKeyByIndex,
        completedKeySet: effectiveCompletedSet,
      });

      const isUnlocked = isCompleted || (isUnlockedByFlow && canUnlockJumpByFinalTest);

      updatedProgress[key] = {
        completed: isCompleted,
        unlocked: isUnlocked
      };
    });
  });

  setLessonProgress(updatedProgress);
})

        .catch(err => {
          // Dacă nu merge fetch-ul, măcar să nu blocheze restul
          setLessonProgress(progressUnlocked);
        });
    })
    .catch((err) => {
      console.error('Eroare la fetch capitole:', err);
    });
}, [courseConfig]);


// Oprește loading-ul paginii când ambele fetch-uri sunt complete
useEffect(() => {
  if (!loading && chapters.length > 0) {
    // Adaugă un mic delay pentru o tranziție plăcută
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }
}, [loading, chapters]);

useEffect(() => {
  if (!updatedProgress) return;

  const normalizedUpdatedProgress = Object.fromEntries(
    Object.entries(updatedProgress)
      .filter(([key]) => String(key).includes('-'))
      .map(([key, value]) => {
        if (value && typeof value === 'object') {
          return [key, value];
        }

        // fallback: dacă vine boolean, îl transformăm în status obiect
        const completed = Boolean(value);
        return [key, { completed, unlocked: completed }];
      })
  );

  if (!Object.keys(normalizedUpdatedProgress).length) return;

  setLessonProgress((prevProgress) => {
    const mergedProgress = {
      ...prevProgress,
      ...normalizedUpdatedProgress,
    };

    const chapterFinalTestKeyByIndex = getChapterFinalTestKeyByIndex(chapters);
    const getCompletedKeySet = () =>
      new Set(
        Object.entries(mergedProgress)
          .filter(([, status]) => status?.completed)
          .map(([key]) => key)
      );

    Object.entries(normalizedUpdatedProgress).forEach(([lessonKey, status]) => {
      if (!status?.completed) return;

      const [chapterIdStr, lessonIdStr] = String(lessonKey).split('-');
      const chapterIndex = chapters.findIndex(
        (chapter) => String(chapter.id) === String(chapterIdStr)
      );
      if (chapterIndex === -1) return;
      const currentChapter = chapters[chapterIndex];
      const lessonIndex = currentChapter.lessons?.findIndex(
        (lesson) => String(lesson.lesson) === String(lessonIdStr)
      );
      if (lessonIndex === -1) return;

      // Dacă lecția completată este jumphere, marchează toate lecțiile anterioare necompletate ca finalizate
      const completedLesson = currentChapter.lessons[lessonIndex];
   
if (
  completedLesson?.explanationType?.toLowerCase() ===
  'jumphere'
) {
  // Completam doar lectiile anterioare
  // din modulul curent.

  for (let l = 0; l < lessonIndex; l++) {
    const previousLesson =
      currentChapter.lessons[l];

    const previousKey =
      `${currentChapter.id}-${previousLesson.lesson}`;

    if (!mergedProgress[previousKey]?.completed) {
      mergedProgress[previousKey] = {
        ...(mergedProgress[previousKey] || {}),
        completed: true,
        unlocked: true,
      };
    }
  }
}


      let nextLessonKey = null;
      let nextLessonChapterIndex = null;
      let nextLessonData = null;
      if (lessonIndex < currentChapter.lessons.length - 1) {
        const nextLesson = currentChapter.lessons[lessonIndex + 1];
        nextLessonKey = `${currentChapter.id}-${nextLesson.lesson}`;
        nextLessonChapterIndex = chapterIndex;
        nextLessonData = nextLesson;
      } else if (chapterIndex < chapters.length - 1) {
        const nextChapter = chapters[chapterIndex + 1];
        const firstLessonNextChapter = nextChapter.lessons?.[0];
        if (firstLessonNextChapter) {
          nextLessonKey = `${nextChapter.id}-${firstLessonNextChapter.lesson}`;
          nextLessonChapterIndex = chapterIndex + 1;
          nextLessonData = firstLessonNextChapter;
        }
      }
      if (nextLessonKey) {
        const nextIsJumpHere =
          nextLessonData?.explanationType?.toLowerCase() === 'jumphere';
        const canUnlockNextJumpByFinalTest = canUnlockJumpHereForChapter({
          chapterIndex: nextLessonChapterIndex,
          isJumpHere: nextIsJumpHere,
          chapterFinalTestKeyByIndex,
          completedKeySet: getCompletedKeySet(),
        });

        if (!nextIsJumpHere || canUnlockNextJumpByFinalTest || mergedProgress[nextLessonKey]?.completed) {
        mergedProgress[nextLessonKey] = {
          ...(mergedProgress[nextLessonKey] || {}),
          unlocked: true,
        };
        }
      }

      
// Daca urmatoarea lectie este JumpHere,
// iar lectia curenta tocmai a fost completata,
// deblocam si lectia de dupa JumpHere.

const followingLesson =
  currentChapter.lessons?.[lessonIndex + 1];

const lessonAfterJump =
  currentChapter.lessons?.[lessonIndex + 2];

if (
  String(followingLesson?.explanationType || '')
    .toLowerCase() === 'jumphere' &&
  lessonAfterJump &&
  mergedProgress[lessonKey]?.completed
) {
  const afterJumpKey =
    `${currentChapter.id}-${lessonAfterJump.lesson}`;

  mergedProgress[afterJumpKey] = {
    ...(mergedProgress[afterJumpKey] || {}),
    unlocked: true
  };
}

    });


    return mergedProgress;
  });
}, [updatedProgress, chapters]);

// Functia handleLessonClick trebuie sa fie definita inainte de a fi folosita in JSX
const handleLessonClick = async (
  chapterId,
  lessonId,
  options = {}
) => {
  const {
    isReplayLesson = false,
    isActualJump = false
  } = options;

  setLoadingLesson(true);

  try {
    const lessonPath =
      courseConfig.lessonUrl(
        chapterId,
        lessonId
      );

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${lessonPath}`,
      {
        credentials: 'include'
      }
    );

    let lessonData = {};

    if (response.ok) {
      lessonData =
        await response.json();
    } else {
      lessonData = {
        title: 'Lectie indisponibila',
        content:
          'Aceasta lectie nu este inca disponibila.'
      };
    }

    tothelesson(
      '/chaptercontainer',
      {
        state: {
          chapterId,
          lessonId,
          lessonData,
          isReplayLesson,
          isActualJump,
          courseId:
            courseConfig.courseId,
          courseName:
            courseConfig.courseName
        }
      }
    );
  } catch (error) {
    tothelesson(
      '/chaptercontainer',
      {
        state: {
          chapterId,
          lessonId,
          isReplayLesson,
          isActualJump,
          courseId:
            courseConfig.courseId,
          courseName:
            courseConfig.courseName,
          lessonData: {
            title: 'Eroare',
            content:
              'Nu am putut incarca lectia.'
          }
        }
      }
    );
  } finally {
    setLoadingLesson(false);
  }
};


// Asigură-te că handleClickOutside este definit (mută-l mai sus dacă e necesar)

// scroll → închide panelul

// useEffect corectat sau eliminat dacă nu e folosit




useEffect(() => {
  if (!floatingLesson) return;

  const lessonKey = `${floatingLesson.chapterId}-${floatingLesson.lessonId}`;
  const lessonEl = lessonRefs.current[lessonKey];

  if (lessonEl) {
    skipNextScrollClose.current = true;
    isUserScrolling.current = false;

    // ⚠️ Găsim containerul scrollabil
const scrollableContainer = scrollerRef.current;


    if (scrollableContainer) {
      const containerRect = scrollableContainer.getBoundingClientRect();
      const lessonRect = lessonEl.getBoundingClientRect();

      const offsetTop = lessonRect.top - containerRect.top;
      const centeredScroll = offsetTop + scrollableContainer.scrollTop - scrollableContainer.clientHeight / 2 + lessonRect.height / 2;

      scrollableContainer.scrollTo({
        top: centeredScroll,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      skipNextScrollClose.current = false;
    }, 500);
  }
}, [floatingLesson]);



useEffect(() => {
  if (justClosedRef.current) {
    const timeout = setTimeout(() => {
      justClosedRef.current = false;
    }, 300); // delay suficient

    return () => clearTimeout(timeout);
  }
}, [floatingLesson]);




useEffect(() => {
  const handleClickOutside = (event) => {
  setTimeout(() => {
    if (
      floatingPanelWrapperRef.current &&
      !floatingPanelWrapperRef.current.contains(event.target)
    ) {
      setFloatingLesson(null);
    }
  }, 0);
};

  if (floatingLesson) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [floatingLesson]);





useEffect(() => {
  const handleUserScroll = () => {
    isUserScrolling.current = true;
    // Close floating lesson panel if open
    if (floatingLesson) {
      setFloatingLesson(null);
    }
  };

  window.addEventListener('wheel', handleUserScroll, { passive: true });
  window.addEventListener('touchmove', handleUserScroll, { passive: true });

  return () => {
    window.removeEventListener('wheel', handleUserScroll);
    window.removeEventListener('touchmove', handleUserScroll);
  };
}, [floatingLesson]);



useEffect(() => {
  if (!floatingLesson) {
    isUserScrolling.current = false;
  }
}, [floatingLesson]);


    const getLessonIconColor = (status) => {
      switch (status) {
        case 'locked':
          return '#9ca3af'; // gri
        case 'unlocked':
          return '#9ca3af'; // gri
        case 'completed':
          return '#22c55e'; // verde
        default:
          return '#10b981'; // fallback: mentă
      }
    };
    

const [firstAvailableLessonKey, setFirstAvailableLessonKey] = useState(null);


const isNormalizedJumpHereLesson = (
  lesson,
  lessonKey
) => {
  const lessonType =
    String(lesson?.explanationType || '')
      .toLowerCase();

  if (lessonType !== 'jumphere') {
    return false;
  }

  for (const chapter of chapters) {
    const lessons = chapter.lessons || [];

    const lessonIndex = lessons.findIndex(
      (item) =>
        `${chapter.id}-${item.lesson}` === lessonKey
    );

    if (lessonIndex === -1) {
      continue;
    }

    // Nu verificam lectii din alte module.
    if (lessonIndex === 0) {
      return false;
    }

    const previousLesson =
      lessons[lessonIndex - 1];

    const previousKey =
      `${chapter.id}-${previousLesson.lesson}`;

    return Boolean(
      lessonProgress[previousKey]?.completed
    );
  }

  return false;
};


const getDisplayedLessonTitle = (lesson, isCompletedLesson) => {
  const lessonType = String(lesson?.explanationType || '').toLowerCase();

  if (lessonType === 'jumphere' && isCompletedLesson) {
    return 'Devino mai bun';
  }

  return lesson?.title || '';
};


useEffect(() => {
  if (
    !courseStateLoaded ||
    !Object.keys(lessonProgress).length
  ) {
    setFirstAvailableLessonKey(null);
    return;
  }

  let nextFirstAvailableKey = null;

  // ==========================================
  // MODUL SEPARAT
  // ==========================================
  if (
    learningMode === 'module' &&
    selectedChapterId !== null
  ) {
    
const selectedChapter = chapters.find(
  (chapter) =>
    String(chapter.id) === String(selectedChapterId)
);

if (selectedChapter) {
  const lessons = selectedChapter.lessons || [];

  for (let idx = 0; idx < lessons.length; idx++) {
    const lesson = lessons[idx];

    const lessonType =
      String(lesson.explanationType || '')
        .toLowerCase();

    // JumpHere nu este lectie curenta.
    if (lessonType === 'jumphere') {
      continue;
    }

    const key =
      `${selectedChapter.id}-${lesson.lesson}`;

    const status = lessonProgress[key];

    if (status?.completed) {
      continue;
    }

    // Aceeasi regula ca la deblocarea vizuala
    // a lectiilor din modulul selectat.
  
const previousLesson =
  idx > 0 ? lessons[idx - 1] : null;

const previousLessonKey =
  previousLesson
    ? `${selectedChapter.id}-${previousLesson.lesson}`
    : null;

const isUnlockedInSelectedModule =
  idx === 0 ||
  Boolean(
    previousLessonKey &&
    lessonProgress[previousLessonKey]?.completed
  ) ||
  Boolean(
    previousLesson &&
    previousLessonKey &&
    isNormalizedJumpHereLesson(
      previousLesson,
      previousLessonKey
    )
  );


    if (!isUnlockedInSelectedModule) {
      continue;
    }

    nextFirstAvailableKey = key;
    break;
  }
}

setFirstAvailableLessonKey(nextFirstAvailableKey);
return;
}

  // ==========================================
  // TRASEUL PROGRESIV NORMAL
  // ==========================================
 
for (const chapter of chapters) {
  for (const lesson of chapter.lessons || []) {
    // Nu selectam JumpHere ca lectie curenta.
    if (
      String(lesson.explanationType || '')
        .toLowerCase() === 'jumphere'
    ) {
      continue;
    }

    const key = `${chapter.id}-${lesson.lesson}`;
    const status = lessonProgress[key];

    if (status?.unlocked && !status?.completed) {
      nextFirstAvailableKey = key;
      break;
    }
  }

  if (nextFirstAvailableKey) {
    break;
  }
}


  // Fallback pentru traseul progresiv
  if (!nextFirstAvailableKey) {
  
const fallbackEntry =
  Object.entries(lessonProgress).find(
    ([key, status]) => {
      const isJumpHere = chapters.some(
        (chapter) =>
          (chapter.lessons || []).some(
            (lesson) =>
              `${chapter.id}-${lesson.lesson}` === key &&
              String(lesson.explanationType || '')
                .toLowerCase() === 'jumphere'
          )
      );

      return (
        !isJumpHere &&
        status?.unlocked &&
        !status?.completed
      );
    }
  );


    nextFirstAvailableKey =
      fallbackEntry
        ? fallbackEntry[0]
        : null;
  }

  setFirstAvailableLessonKey(nextFirstAvailableKey);

}, [
  lessonProgress,
  chapters,
  learningMode,
  selectedChapterId,
  courseStateLoaded
]);



const hasAutoScrolled = useRef(false);


const startSeparateModule = async (chapter, chapterIndex) => {
  const previousLearningMode = learningMode;
  const previousSelectedChapterId = selectedChapterId;

  // Actualizam imediat interfata
  setLearningMode('module');
  setSelectedChapterId(chapter.id);

  setActiveChapters((prev) => ({
    ...prev,
    [chapterIndex]: true
  }));

  setFloatingLesson(null);
  hasAutoScrolled.current = false;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/course-state`,
      {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          courseId: courseConfig.courseId,
          learningMode: 'module',
          selectedChapterId: chapter.id
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Nu s-a putut salva modulul selectat'
      );
    }

  } catch (error) {
    console.error(
      'Eroare la salvarea modulului selectat:',
      error
    );

    // Daca DB nu a putut salva schimbarea,
    // revenim la starea anterioara.
    setLearningMode(previousLearningMode);
    setSelectedChapterId(previousSelectedChapterId);
  }
};


const returnToProgressivePath = async () => {
  const previousLearningMode = learningMode;
  const previousSelectedChapterId = selectedChapterId;

  // Actualizam imediat interfata
  setLearningMode('progressive');
  setSelectedChapterId(null);

  setFloatingLesson(null);
  hasAutoScrolled.current = false;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/course-state`,
      {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          courseId: courseConfig.courseId,
          learningMode: 'progressive',
          selectedChapterId: null
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Nu s-a putut salva revenirea la traseul progresiv'
      );
    }

  } catch (error) {
    console.error(
      'Eroare la salvarea traseului progresiv:',
      error
    );

    setLearningMode(previousLearningMode);
    setSelectedChapterId(previousSelectedChapterId);
  }
};


const goToCurrentLesson = () => {
  if (!firstAvailableLessonKey) return;

  const [chapterIdStr, lessonIdStr] =
    String(firstAvailableLessonKey).split('-');

  const chapterIndex = chapters.findIndex(
    (chapter) =>
      String(chapter.id) === String(chapterIdStr)
  );

  if (chapterIndex === -1) return;

  const isChapterCollapsed =
    !activeChapters[chapterIndex];

  // Daca modulul este strans, il deschidem mai intai.
  if (isChapterCollapsed) {
    setActiveChapters((prev) => ({
      ...prev,
      [chapterIndex]: true
    }));
  }

  setFloatingLesson(null);

  /*
   * Asteptam ca React sa afiseze lectiile modulului.
   * Daca modulul era deja deschis, functia va gasi
   * elementul aproape imediat.
   */
  let retryCount = 0;
  const MAX_RETRIES = 30;

  const scrollToLesson = () => {
    const scroller = scrollerRef.current;

    const lessonEl =
      lessonRefs.current[firstAvailableLessonKey];

    if (!scroller || !lessonEl) {
      retryCount += 1;

      if (retryCount <= MAX_RETRIES) {
        requestAnimationFrame(scrollToLesson);
      }

      return;
    }

    const containerRect =
      scroller.getBoundingClientRect();

    const lessonRect =
      lessonEl.getBoundingClientRect();

    const offsetTop =
      lessonRect.top -
      containerRect.top +
      scroller.scrollTop;

    scroller.scrollTo({
      top:
        offsetTop -
        scroller.clientHeight / 3,
      behavior: 'smooth'
    });

    // Deschidem si cardul lectiei curente.
    setTimeout(() => {
      setFloatingLesson({
        chapterId: chapterIdStr,
        lessonId: lessonIdStr
      });
    }, 300);
  };

  requestAnimationFrame(scrollToLesson);
};

useEffect(() => {
  if (!updatedProgress || !Object.keys(updatedProgress).length) return;

  // Când revenim dintr-o lecție (inclusiv Refa lectia),
  // permitem repoziționarea pe lecția curentă.
  hasAutoScrolled.current = false;
}, [updatedProgress]);

useEffect(() => {
  hasAutoScrolled.current = false;
  hasScrolledToCertificate.current = false;
}, [location.key]);

useEffect(() => {
  // Daca tot cursul este terminat,
  // certificatul are prioritate fata de lectii.
  if (isCourseCompleted) return;

  if (
    !firstAvailableLessonKey ||
    hasAutoScrolled.current ||
    pageLoading
  ) {
    return;
  }

  let isCancelled = false;
  let retryCount = 0;
  const MAX_RETRIES = 24;

  const tryAutoScrollToCurrentLesson = () => {
    if (isCancelled || hasAutoScrolled.current) return;

    const scroller = scrollerRef.current;
    const lessonEl = lessonRefs.current[firstAvailableLessonKey];

    if (!scroller || !lessonEl) {
      retryCount += 1;
      if (retryCount <= MAX_RETRIES) {
        requestAnimationFrame(tryAutoScrollToCurrentLesson);
      }
      return;
    }

    hasAutoScrolled.current = true;

    const containerRect = scroller.getBoundingClientRect();
    const lessonRect = lessonEl.getBoundingClientRect();
    const offsetTop = lessonRect.top - containerRect.top;

    scroller.scrollTo({
      top: offsetTop - scroller.clientHeight / 3,
      behavior: 'smooth'
    });

    const [chapterIdStr, lessonIdStr] = String(firstAvailableLessonKey).split('-');
    setTimeout(() => {
      if (isCancelled) return;
      setFloatingLesson({
        chapterId: chapterIdStr,
        lessonId: lessonIdStr,
      });
    }, 250);
  };

  const startTimer = setTimeout(() => {
    requestAnimationFrame(tryAutoScrollToCurrentLesson);
  }, 120);

  return () => {
    isCancelled = true;
    clearTimeout(startTimer);
  };
}, [
  firstAvailableLessonKey,
  lessonProgress,
  pageLoading,
  location.key,
  isCourseCompleted
]);



const hasRequestedCertificate = useRef(null);

useEffect(() => {
  if (!isCourseCompleted) return;
 const currentCourseId = Number(courseConfig.courseId);

if (hasRequestedCertificate.current === currentCourseId) {
  return;
}

hasRequestedCertificate.current = currentCourseId;

  fetch(
    `${process.env.REACT_APP_API_URL}/certificates/issue`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        course_id: Number(courseConfig.courseId),
        course_name: courseConfig.courseName
      })
    }
  )
    .then(async (res) => {
      const data = await res.json().catch(() => ({}));

      // 400/403: certificat indisponibil pentru acest curs/cont - nu reincercam.
      if (res.status === 400 || res.status === 403) {
        return;
      }

      if (!res.ok) {
        throw new Error(
          data?.error ||
          'Certificatul nu a putut fi emis'
        );
      }

      console.log(
        'Certificat emis:',
        data
      );
    })
    .catch((error) => {
      console.error(
        'Eroare emitere certificat:',
        error
      );

      // Permitem retry daca a esuat
      if (hasRequestedCertificate.current === currentCourseId) {
  hasRequestedCertificate.current = null;
}
    });

}, [isCourseCompleted, courseConfig.courseId, courseConfig.courseName]);


useEffect(() => {
  if (!justClosedRef.current) return;

  const timer = setTimeout(() => {
    justClosedRef.current = false;
  }, 300);

  return () => clearTimeout(timer);
}, [justClosedRef.current]);


useEffect(() => {
  if (floatingLesson === null) {
    const timer = setTimeout(() => {
      justClosedRef.current = false;
    }, 300);

    return () => clearTimeout(timer);
  }
}, [floatingLesson]);




useEffect(() => {
  const key = firstAvailableLessonKey;
  const lessonEl = lessonRefs.current[key];
  const scroller = scrollerRef.current;

  if (!key || !lessonEl || !scroller) return;

  const updatePosition = () => {
    const lessonRect = lessonEl.getBoundingClientRect();
    const buttonEl = document.querySelector('.scroll-to-active-lesson-bc');

    // ✅ Determină dacă lecția e vizibilă
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isVisible =
      lessonRect.top >= 0 &&
      lessonRect.bottom <= windowHeight;

    setIsActiveLessonVisible(isVisible);

    // ✅ Determină direcția
    if (buttonEl) {
      const buttonTop = buttonEl.getBoundingClientRect().top;
      setScrollDirectionUp(lessonRect.top < buttonTop); // 🧠 dacă lecția e mai sus decât butonul, arătăm în sus
    }
  };

  // ✅ Rulează inițial (după un frame)
  const raf = requestAnimationFrame(updatePosition);

  // ✅ Rulează la scroll
  const onScroll = () => {
    updatePosition();
  };

  const scrollContainer = scrollerRef.current || window;
  scrollContainer.addEventListener('scroll', onScroll, { passive: true });

  return () => {
    cancelAnimationFrame(raf);
    scrollContainer.removeEventListener('scroll', onScroll);
  };
}, [
  firstAvailableLessonKey,
  activeChapters
]);



useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      setHideScrollButton(entry.isIntersecting);
    },
    {
      root: null, // se uită în viewport-ul paginii
      threshold: 0.1,
    }
  );

  if (congratsRef.current) {
    observer.observe(congratsRef.current);
  }

  return () => {
    if (congratsRef.current) {
      observer.unobserve(congratsRef.current);
    }
  };
}, []);






    const getLessonLeftIconColor = (lesson, lessonKey) => {
      const type = lesson.explanationType || lesson.title;

      if (isNormalizedJumpHereLesson(lesson, lessonKey)) return '#ffffffff';
    
      if (type.toLowerCase().includes('practica')) return 'rgba(255, 255, 255, 1)';
      if (type.toLowerCase().includes('aplicatie')) return '#ffffffff';
      if (type.toLowerCase().includes('lectie')) return '#ffffffff';
       if (type.toLowerCase().includes('introducere')) return '#ffffffff';
      if (type.toLowerCase().includes('avanseaza')) return '#ffffffff';
      if (type.toLowerCase().includes('safebadge')) return '#ffffffff';
      if (type.toLowerCase().includes('recapitulare')) return '#ffffffff';

      


      if (type.toLowerCase().includes('test')) return 'rgba(255, 255, 255, 1)';
      return '#ffffffff';
    };
    
    
const getLessonLeftIcon = (lesson, lessonKey, chapter, idx) => {
      const type = lesson.explanationType?.toLowerCase() || lesson.title?.toLowerCase();

      if (isNormalizedJumpHereLesson(lesson, lessonKey)) return faBoltLightning;
    
      if (type.includes('practica')) return faDumbbell;
        if (type === 'contcontabil') {
    return faScaleBalanced;
  }
      if (type.includes('aplicatie')) return faPuzzlePiece;
      if (type.includes('test')) return faTrophy;
      if (type.includes('lectie')) return faGraduationCap;
   






        if (type.includes('introducere')) return faPlay; 
      if (type.includes('jumphere')) return faForwardFast; 
      if (type.includes('safebadge')) return faForwardFast; 
      if (type.includes('recapitulare')) return faForwardFast; 
      return faBookOpen; // fallback general
    };
    


    const currentLessonChapterIndex =
  firstAvailableLessonKey
    ? chapters.findIndex((chapter) =>
        (chapter.lessons || []).some(
          (lesson) =>
            `${chapter.id}-${lesson.lesson}` ===
            firstAvailableLessonKey
        )
      )
    : -1;

const isCurrentLessonChapterCollapsed =
  currentLessonChapterIndex !== -1 &&
  !activeChapters[currentLessonChapterIndex];


    return (
<div
  className="componentsmenu-container-main"
  style={{
    '--course-primary': theme.primary,
    '--course-light': theme.light,
    '--course-dark': theme.dark,
    '--course-darker': theme.darker,
  }}
>
      <div className="componentsmenu-left-blank-lessons"></div>
     

        
      {pageLoading && (
        <div className="welcome-screen-lesson">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {loadingLesson && (
        <div className="welcome-screen-lesson">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      
    
<div className='container-show-lessons'>
  <div className="chapter-main-content">

    {previewChapter && isDesktop && (
      <ChapterPreview
        chapter={previewChapter}
        onClose={() => setPreviewChapter(null)}
      />
    )}

    {(!previewChapter || !isDesktop) && showLessonsMain ? (

      <div className='body-lessons-bc-framework'>

        <div
          className='line-lesson-gackground-functional'
          ref={scrollerRef}
        >

          <div className="chapter-header-sticky-wrapper-stats">
            <div className="statscard-sticky">
              <TopBar />
            </div>
          </div>

          {chapters.map((chapter, index) => (
            <div
              key={chapter.id}
              className="chapter-block"
            >

              <div className="chapter-header-sticky-wrapper">

               <div
  className={`chapter-containerbc ${
    learningMode === 'module' &&
    String(selectedChapterId) === String(chapter.id)
      ? 'selected-module-header'
      : ''
  }`}
>
<button
  type="button"
  className={`db-data-title-button module-learning-button ${
    learningMode === 'module' &&
    String(selectedChapterId) === String(chapter.id)
      ? 'selected-learning-module'
      : ''
  }`}
onClick={() => {
  setModuleSelectionPopup({
    chapter,
    chapterIndex: index
  });
}}
>
<div className='title-module-orientation'>
  <p className="modul-name">
    {chapter.module}
  </p>

  <p className="title-modul-name">
    {chapter.title}
  </p>
</div>
  

  <span className="module-learning-label">
    {learningMode === 'module' &&
    String(selectedChapterId) === String(chapter.id)
      ? 'Revino la traseul meu'
      : 'Invata acest modul'}
  </span>
</button>

                  <div className="button-right-chapter">

  {/* SUS - Ce vei invata */}
  <button
    type="button"
    className="chapter-action-button chapter-preview-button"
    onClick={() => {
      setPreviewChapter(chapter);
    }}
    aria-label={`Vezi prezentarea modulului ${chapter.title}`}
    title="Ce vei invata"
  >
    <img
      src={chaptericon}
      alt=""
    />
  </button>

  {/* JOS - Restrange / extinde */}
  <button
    type="button"
    className="chapter-action-button chapter-collapse-button"
   onClick={(event) => {
  toggleChapter(index, event);
}}
    aria-label={
      activeChapters[index]
        ? `Restrange modulul ${chapter.title}`
        : `Extinde modulul ${chapter.title}`
    }
    title={
      activeChapters[index]
        ? "Restrange modulul"
        : "Extinde modulul"
    }
  >
    <FontAwesomeIcon
      icon={
        activeChapters[index]
          ? faChevronUp
          : faChevronDown
      }
      className="chapter-collapse-icon"
    />
  </button>

</div>

                </div>

              </div>

              <div className="general-framework-bc-mobile"></div>

              <div
                className={`chapter-lessons-wrapper ${
                  activeChapters[index]
                    ? 'displaying-show-chapters'
                    : 'displaying-none-chapters'
                }`}
              >

                {chapter.lessons?.map((lesson, idx) => {
                 const k =
  `${chapter.id}-${lesson.lesson}`;

  

const isPremiumBlocked =
  isFinancialCourse &&
  !premiumStatus.isPremium &&
  !freeFinancialLessonKeys.includes(k);



const isCompleted =
  Boolean(lessonProgress[k]?.completed);

const isSelectedSeparateModule =
  learningMode === 'module' &&
  String(selectedChapterId) === String(chapter.id);


  
/* ==========================================
   URMATORUL JUMPHERE DIN MODUL
========================================== */

const nextJumpHereIndex =
  chapter.lessons.findIndex((item) => {
    const isJump =
      String(item.explanationType || '')
        .toLowerCase() === 'jumphere';

    const key =
      `${chapter.id}-${item.lesson}`;

    return (
      isJump &&
      !lessonProgress[key]?.completed
    );
  });



let isUnlockedForDisplay =
  Boolean(lessonProgress[k]?.unlocked);

// Daca utilizatorul a ales sa invete separat acest modul,
// progresia se calculeaza doar in interiorul modulului.
if (isSelectedSeparateModule) {

  // Lectiile deja terminate raman accesibile
  if (isCompleted) {
    isUnlockedForDisplay = true;
  }

  // Prima lectie poate fi inceputa direct
  else if (idx === 0) {
    isUnlockedForDisplay = true;
  }

  // Pentru restul lectiilor verificam doar lectia
  // anterioara din acelasi modul
 
else {
  const previousLesson =
    chapter.lessons[idx - 1];

  const previousLessonKey =
    `${chapter.id}-${previousLesson.lesson}`;

  isUnlockedForDisplay =
    Boolean(
      lessonProgress[previousLessonKey]?.completed
    ) ||
    isNormalizedJumpHereLesson(
      previousLesson,
      previousLessonKey
    );
}

}




/* ==========================================
   JUMPHERE - CONTROL ACCES
========================================== */

const isJumpHereLesson =
  String(lesson.explanationType || '')
    .toLowerCase() === 'jumphere';

const isModuleLearning =
  learningMode === 'module' &&
  selectedChapterId !== null;

if (isJumpHereLesson) {

  if (isModuleLearning) {

    if (isSelectedSeparateModule) {

      // MODUL SELECTAT:
      // Activam doar urmatorul JumpHere
      // nefinalizat din modul.
      isUnlockedForDisplay =
        isCompleted ||
        idx === nextJumpHereIndex;

    } else {

      // MODUL NESELECTAT:
      // JumpHere blocat.
      isUnlockedForDisplay = false;
    }

  } else {

    // TRASEU NORMAL:
    // JumpHere respecta progresul general.
    // Nu activam automat toate JumpHere.

    isUnlockedForDisplay =
      isCompleted ||
      Boolean(lessonProgress[k]?.unlocked);
  }
}


const isInactive =
  !isUnlockedForDisplay || isPremiumBlocked;




const isCompletedJumpInOtherModule =
  isJumpHereLesson &&
  isCompleted &&
  learningMode === 'module' &&
  !isSelectedSeparateModule;

// O lectie JumpHere deja completata isi pastreaza
// aspectul de lectie finalizata, chiar daca
// modulul nu este selectat.
const shouldGrayOut =
  isInactive &&
  !isCompletedJumpInOtherModule;


const isFirstAvailable =
  firstAvailableLessonKey ===
  `${chapter.id}-${lesson.lesson}`;

                  const isCenterLesson =
                    String(floatingLesson?.chapterId) ===
                      String(chapter.id) &&
                    String(floatingLesson?.lessonId) ===
                      String(lesson.lesson);

                  const lessonType =
                    lesson.explanationType?.toLowerCase() || '';

                  const isNormalizedJumpHere =
                    isNormalizedJumpHereLesson(
                      lesson,
                      k
                    );

                  const isGiftLesson =
                    lessonType === 'giftlesson' ||
                    lessonType === 'safebadge';

                  const isGiftOpened =
                    isGiftLesson &&
                    Boolean(isCompleted);

                  const isCompletedLesson =
                    Boolean(
                      lessonProgress?.[
                        `${chapter.id}-${lesson.lesson}`
                      ]?.completed
                    );

                  const displayedLessonTitle =
                    getDisplayedLessonTitle(
                      lesson,
                      isCompletedLesson
                    );

                  const pattern = [
                    'align-center-odd',
                    'align-left',
                    'align-center-even',
                    'align-left',
                    'align-center-odd',
                    'align-right-four',
                    'align-right'
                  ];

                  const serpentineClass =
                    pattern[idx % pattern.length];

                  return (
                    <React.Fragment
                      key={`${chapter.id}-${lesson.lesson}`}
                    >

                      <div
                        className={`serpentine-wrapper ${serpentineClass} ${
                          isCenterLesson
                            ? 'selected-wrapper'
                            : ''
                        }`}
                      >

                        <div
                          className={`lesson-show-mainbc ${
                            isCenterLesson
                              ? 'selected-lesson'
                              : ''
                          }`}
                          ref={(el) => {
                            lessonRefs.current[k] = el;
                          }}
                        >

                          <div
                            className="symbol-lesson"
                           
style={
  shouldGrayOut
    ? {
        filter: 'grayscale(1)',
        opacity: 0.5
      }
    : {}
}

                          >

                            {isFirstAvailable &&
                              (
                                lesson.explanationType?.toLowerCase() !==
                                  'jumphere' ||
                                isNormalizedJumpHere
                              ) &&
                              !isCenterLesson &&
                              floatingLesson === null && (

                                <div className="start-bubble-wrapper">
                                  <FloatingLessonBubble />
                                </div>

                              )}

                            <div
                              className={`costomize-icon-lesson ${
                                isFirstAvailable
                                  ? 'glow-effectbc'
                                  : ''
                              }`}
                            >

                              <div
                                className={`align-items-lessons-inside-show
                                  ${
                                    lesson.explanationType?.toLowerCase() ===
                                    'safebadge'
                                      ? 'no-inner-bg'
                                      : ''
                                  }
                                  ${
                                    lesson.explanationType?.toLowerCase() ===
                                    'recapitulare'
                                      ? 'recap-lesson'
                                      : ''
                                  }
                                  ${
                                    lesson.explanationType?.toLowerCase() ===
                                    'aplicatie'
                                      ? 'application-lesson'
                                      : ''
                                  }
                                  ${
                                    lesson.explanationType?.toLowerCase() ===
                                    'test'
                                      ? 'test-lesson'
                                      : ''
                                  }
                                  ${
                                    lesson.explanationType?.toLowerCase() ===
                                      'jumphere' &&
                                    !isNormalizedJumpHere
                                      ? 'jump-here-lesson'
                                      : ''
                                  }
                                  ${
                                    lesson.explanationType?.toLowerCase() ===
                                      'jumphere' &&
                                    isNormalizedJumpHere &&
                                    !isGiftLesson
                                      ? 'current-lesson-icon'
                                      : ''
                                  }
                                `}
                                onClick={(event) => {
                                  event.stopPropagation();

                                  if (
                                    isGiftLesson &&
                                    isCompletedLesson
                                  ) {
                                    setFloatingLesson(null);
                                    return;
                                  }

                                  const lessonIdStr =
                                    String(lesson.lesson);

                                  const chapterIdStr =
                                    String(chapter.id);

                                  const clickedLessonKey =
                                    `${chapterIdStr}-${lessonIdStr}`;

                                  const currentLessonKey =
                                    floatingLesson
                                      ? `${floatingLesson.chapterId}-${floatingLesson.lessonId}`
                                      : null;

                                  if (
                                    clickedLessonKey ===
                                    currentLessonKey
                                  ) {
                                    setFloatingLesson(null);
                                    return;
                                  }

                                  scrollProtectorRef.current = true;
                                  skipNextScrollClose.current = true;
                                  isUserScrolling.current = false;

                                  setTimeout(() => {
                                    setFloatingLesson({
                                      chapterId: chapterIdStr,
                                      lessonId: lessonIdStr,
                                      title:
                                        displayedLessonTitle
                                    });
                                  }, 0);

                                  setTimeout(() => {
                                    scrollProtectorRef.current = false;
                                  }, 600);
                                }}
                              >

                                {isGiftLesson ? (

                                  <img
                                    src={
                                      isGiftOpened
                                        ? giftOpen
                                        : giftClosed
                                    }
                                    alt="Gift lesson"
                                    className="safebadge-icon"
                                  />

                                ) : lesson.explanationType?.toLowerCase() ===
                                  'recapitulare' ? (

                                  <img
                                    src={brainreview}
                                    alt="Recapitulare"
                                    className="recapitulare-icon-bc"
                                  />

                                ) : lesson.explanationType?.toLowerCase() ===
                                  'jumphere' ? (

                                  <FontAwesomeIcon
                                    icon={
                                      isNormalizedJumpHere
                                        ? faBoltLightning
                                        : faForwardFast
                                    }
                                    className={
                                      isNormalizedJumpHere
                                        ? 'symbol-item-lesson'
                                        : 'symbol-item-lesson-jump-bc'
                                    }
                                    style={{
                                      color:
                                        getLessonLeftIconColor(
                                          lesson,
                                          k
                                        )
                                    }}
                                  />

                                ) : (

                                  <FontAwesomeIcon
                                    icon={getLessonLeftIcon(
                                      lesson,
                                      k,
                                      chapter,
                                      idx
                                    )}
                                    className="symbol-item-lesson"
                                    style={{
                                      color:
                                        getLessonLeftIconColor(
                                          lesson,
                                          k
                                        )
                                    }}
                                  />

                                )}

                              </div>

                            </div>

                            {!floatingLesson && (
                              <span className="lesson-title-right">
                                {displayedLessonTitle}
                              </span>
                            )}

                          </div>

                          {isCenterLesson &&
                            !(
                              isGiftLesson &&
                              isCompletedLesson
                            ) && (
                              <>
                                <div
                                  className={`arrow-floating-bc ${
                                    isCompletedLesson &&
                                    !isGiftLesson
                                      ? 'is-completed'
                                      : ''
                                  } ${
                                    isInactive
                                      ? 'inactive'
                                      : ''
                                  }`}
                                />

                                <div
                                  ref={floatingPanelWrapperRef}
                                >

                                  <div
                                    className="floating-panel-over-lesson-floating-bc"
                                    data-position={
                                      serpentineClass
                                    }
                                  >

                                    <div
                                      className={`panel-card-floating-bc ${
                                        isCompletedLesson &&
                                        !isGiftLesson
                                          ? 'is-completed'
                                          : ''
                                      } ${
                                        isGiftLesson
                                          ? 'panel-card-floating-gift'
                                          : ''
                                      } ${
                                        isCenterLesson &&
                                        !isCompletedLesson &&
                                        !isGiftLesson
                                          ? 'is-current'
                                          : ''
                                      }`}
                                      style={
                                        isInactive
                                          ? {
                                              backgroundColor:
                                                '#afafaf'
                                            }
                                          : {}
                                      }
                                    >

                                      {!isGiftLesson && (
                                        <>
                                          <p className="lesson-title-floating">
                                            {isCenterLesson &&
                                            !isCompletedLesson &&
                                            isNormalizedJumpHere
                                              ? 'Devino mai bun'
                                              : displayedLessonTitle}
                                          </p>

                                         
<p className="lesson-subtitle-floating">
  {isPremiumBlocked
    ? 'Deblocheaza Premium'
    : isInactive
    ? 'Lectie blocata'
    : lessonProgress?.[
        `${chapter.id}-${lesson.lesson}`
      ]?.completed
    ? 'Lectie completa'
    : isCenterLesson
    ? 'Lectia curenta'
    : lesson.explanationType}
</p>

                                        </>
                                      )}

                                      <div
                                        className={`start-lesson-btn-floating-bc ${
                                          isGiftLesson
                                            ? 'start-lesson-btn-gift'
                                            : ''
                                        } ${
                                          isCompletedLesson &&
                                          !isGiftLesson
                                            ? 'is-completed'
                                            : ''
                                        } ${
                                          isInactive
                                            ? 'inactive'
                                            : ''
                                        }`}
                                        
onClick={() => {
  // Curs financiar, lectie Premium,
  // utilizator fara abonament.
  if (isPremiumBlocked) {
    tothelesson('/premium/plans');
    return;
  }

  if (isInactive) {
    return;
  }

  handleLessonClick(
    chapter.id,
    lesson.lesson,
    {
      isReplayLesson:
        isCompletedLesson && !isGiftLesson,

      isActualJump:
        lessonType === 'jumphere' &&
        !isNormalizedJumpHere
    }
  );
}}

                                      >
                                        
{isPremiumBlocked
  ? '🔓 Deblocheaza Premium'
  : isGiftLesson
  ? 'Deschide cadoul'
  : isCompletedLesson
  ? 'Refa lectia'
  : 'Incepe'}

                                      </div>

                                    </div>

                                  </div>

                                </div>
                              </>
                            )}

                        </div>

                      </div>

                      {(
                        index === 0
                          ? (
                              idx + 1 === 12 ||
                              (
                                idx + 1 > 12 &&
                                (idx - 11) % 11 === 0
                              )
                            )
                          : (
                              (idx + 1) % 11 === 0
                            )
                      ) && (

                        <LessonSeparator
                          text={`Ai parcurs ${idx + 1} lectii`}
                        />

                      )}

                    </React.Fragment>
                  );
                })}

              </div>

            </div>
                 ))}

          {moduleSelectionPopup && (
            <div
              className="module-selection-overlay"
              onClick={() => setModuleSelectionPopup(null)}
            >
              <div
                className="module-selection-popup"
                onClick={(event) => event.stopPropagation()}
              >
                <button
                  type="button"
                  className="module-selection-close"
                  onClick={() => setModuleSelectionPopup(null)}
                  aria-label="Inchide"
                >
                  ×
                </button>

                <div className="module-selection-icon">
                  <FontAwesomeIcon icon={faGraduationCap} />
                </div>

                <p className="module-selection-eyebrow">
                  {moduleSelectionPopup.chapter.module}
                </p>

                <h2>
                  {moduleSelectionPopup.chapter.title}
                </h2>

                {learningMode === 'module' &&
                String(selectedChapterId) ===
                  String(moduleSelectionPopup.chapter.id) ? (
                  <>
                    <p className="module-selection-description">
                      Acest modul este selectat pentru invatare separata.
                      Poti reveni oricand la traseul normal al cursului,
                      fara sa pierzi progresul realizat.
                    </p>

                    <button
                      type="button"
                      className="module-selection-confirm progressive"
                      onClick={async () => {
                        await returnToProgressivePath();
                        setModuleSelectionPopup(null);
                      }}
                    >
                      Revino la traseul meu
                    </button>
                  </>
                ) : (
                  <>
                    <p className="module-selection-description">
                      Poti incepe acest modul separat, fara sa finalizezi
                      modulele anterioare. Progresul tau existent ramane
                      salvat.
                    </p>

                    <button
                      type="button"
                      className="module-selection-confirm"
                      onClick={async () => {
                        await startSeparateModule(
                          moduleSelectionPopup.chapter,
                          moduleSelectionPopup.chapterIndex
                        );

                        setModuleSelectionPopup(null);
                      }}
                    >
                      Invata acest modul
                    </button>
                  </>
                )}
              </div>
            </div>
          )}

          <div
            className='congratuation'
            ref={congratsRef}
          >

            <img
              src={road}
              className='road'
              alt=""
            />

            <img
              src={finish}
              className='finish'
              alt=""
            />

            <div className='gray-line-before-share' />

            <div
              className="obtain-certificate-bc"
              ref={certificateRef}
            >

              <img
                src={diploma}
                alt="certificate"
                className={
                  isCourseCompleted
                    ? 'certificate-image-bc'
                    : 'disabled-image-bc'
                }
              />

              <Link
                to={isCourseCompleted ? `/diploma?courseId=${courseConfig.courseId}` : '#'}
                state={
                  isCourseCompleted
                    ? { courseId: courseConfig.courseId }
                    : undefined
                }

                className={[
                  'buton-diploma-bc',

                  isCourseCompleted
                    ? 'buton-diploma-bc-unlocked'
                    : 'buton-diploma-bc-disabled'

                ].join(' ')}
                onClick={(event) => {
                  if (!isCourseCompleted) {
                    event.preventDefault();
                  }
                }}
                aria-disabled={!isCourseCompleted}
                tabIndex={
                  isCourseCompleted
                    ? 0
                    : -1
                }
              >
                Obtine certificatul!
              </Link>

            </div>

            <div className='gray-line-before-share' />

          </div>

          {firstAvailableLessonKey &&
  (
    isCurrentLessonChapterCollapsed ||
    !isActiveLessonVisible
  ) &&
  !hideScrollButton &&
  !floatingLesson &&
  !activePanel && (

              <div
                className="scroll-to-active-lesson-bc"
             onClick={goToCurrentLesson}
                aria-label="Mergi la lectia activa"
              >

                <FontAwesomeIcon
                  icon={
                    scrollDirectionUp
                      ? faArrowUp
                      : faArrowDown
                  }
                  className="icon-arrow-active-bc"
                />

              </div>

            )}

        </div>

      </div>

    ) : null}

    {previewChapter && !isDesktop && (
  <ChapterPreview
    chapter={previewChapter}
    onClose={() => setPreviewChapter(null)}
  />
)}

  </div>
</div>
    



      
      
      </div>



    );
  };

export default ShowLessonsModel;